import { render, staticRenderFns } from "./OrderImport.vue?vue&type=template&id=531cb4ec&scoped=true&"
import script from "./OrderImport.vue?vue&type=script&lang=js&"
export * from "./OrderImport.vue?vue&type=script&lang=js&"
import style0 from "./OrderImport.vue?vue&type=style&index=0&id=531cb4ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531cb4ec",
  null
  
)

export default component.exports